module.exports = __webpack_public_path__ + "img/tyzsbgfdyh.b7157a05.png";